import { useState, useEffect, useCallback } from 'react';
import api from 'services/api';

const PRIO_STYLES = {
  haute: { bg: '#FEF2F2', color: '#DC2626', border: '#FECACA', icon: '!' },
  moyenne: { bg: '#FEF3C7', color: '#D97706', border: '#FDE68A', icon: '~' },
  basse: { bg: '#ECFDF5', color: '#059669', border: '#A7F3D0', icon: 'i' },
};

const TYPE_LABELS = {
  contrat_expiring: 'Contrat expirant',
  facture_impayee: 'Facture impayee',
  site_risque: 'Site a risque',
  agent_fatigue: 'Agent fatigue',
  sous_effectif: 'Sous-effectif',
};

export default function AlertesPredictivesPage() {
  const [alertes, setAlertes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get('/ia/alertes'); setAlertes(r.data); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = filter ? alertes.filter(a => a.type === filter) : alertes;
  const hautes = alertes.filter(a => a.priorite === 'haute').length;
  const moyennes = alertes.filter(a => a.priorite === 'moyenne').length;

  return (
    <div>
      <div className="stats-grid stats-grid--3">
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Alertes totales</span></div>
          <div className="stat-card-value" style={{ color: alertes.length > 0 ? '#DC2626' : '#2e7d32' }}>{alertes.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Priorite haute</span></div>
          <div className="stat-card-value" style={{ color: '#DC2626' }}>{hautes}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Priorite moyenne</span></div>
          <div className="stat-card-value" style={{ color: '#D97706' }}>{moyennes}</div>
        </div>
      </div>

      <div className="content-card">
        <div className="gss-toolbar">
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <div className="content-card-title">Alertes & règles automatiques — Suivi des échéances</div>
            <select className="gss-input" value={filter} onChange={e => setFilter(e.target.value)} style={{ width: 200 }}>
              <option value="">Toutes les alertes</option>
              {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <button className="gss-btn gss-btn-primary" onClick={load} disabled={loading}>Actualiser</button>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Analyse en cours...</p>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: '#2e7d32' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="1.5" style={{ marginBottom: 8 }}>
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
            <p style={{ fontWeight: 600 }}>Aucune alerte</p>
            <p style={{ fontSize: 12, color: '#888' }}>Tout semble en ordre</p>
          </div>
        ) : (
          <div style={{ padding: 8 }}>
            {filtered.map((a, i) => {
              const st = PRIO_STYLES[a.priorite] || PRIO_STYLES.basse;
              return (
                <div key={i} style={{ display: 'flex', gap: 12, padding: '12px 16px', marginBottom: 8, background: st.bg, border: `1px solid ${st.border}`, borderRadius: 8, alignItems: 'flex-start' }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: st.color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, flexShrink: 0 }}>
                    {st.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                      <span className="gss-badge" style={{ background: `${st.color}20`, color: st.color, fontSize: 10 }}>{TYPE_LABELS[a.type] || a.type}</span>
                      <span className="gss-badge" style={{ background: `${st.color}20`, color: st.color, fontSize: 10 }}>{a.priorite}</span>
                    </div>
                    <div style={{ fontSize: 13, color: '#333', fontWeight: 500 }}>{a.message}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
